// extracted by mini-css-extract-plugin
export default {"slotHighlighted":"CN6gb9"};